//
//
//
//
//
//

import Button from '@/components/Shared/Button.vue'
export default {
  components: {
    Button,
  },
  props: {
    iconRight: {
      type: String,
      default: '',
    },
  },
}
